import { Box, makeStyles } from '@material-ui/core';
import { InfoCard } from '@backstage/core-components';
import { AnnouncementsCard } from '@backstage-community/plugin-announcements';
import { useApi, configApiRef } from '@backstage/core-plugin-api';
import AnnouncementIcon from '@material-ui/icons/Announcement';

const useStyles = makeStyles(theme => ({
  cardTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  announcementIcon: {
    color: '#666666',
  },
  announcementsContent: {
    '& > div': {
      boxShadow: 'none',
      border: 'none',
      '& > div:first-child': {
        display: 'none',
      },
    },
  },
}));

export const CustomAnnouncementsCard = () => {
  const classes = useStyles();
  const config = useApi(configApiRef);
  const maxAnnouncements =
    config.getOptionalNumber('announcements.homePage.maxAnnouncements') ?? 3;

  return (
    <InfoCard
      title={
        <Box className={classes.cardTitle}>
          <AnnouncementIcon className={classes.announcementIcon} />
          Announcements
        </Box>
      }
    >
      <div className={classes.announcementsContent}>
        <AnnouncementsCard max={maxAnnouncements} title="" />
      </div>
    </InfoCard>
  );
};
